import {Component, OnDestroy, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../state/appState';
import {Observable, Subscription} from 'rxjs';
import {UserModel} from '../../shared/services/user/user.model';
import {distinctUntilChanged, filter} from 'rxjs/operators';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {UserLogin} from '../../state/actions/appState.account.actions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  @Select(AppState.currentUser$)
  public currentUser: Observable<UserModel>;
  public loginForm: FormGroup;

  private subs: Subscription[] = [];

  constructor(
    private store: Store,
    private router: Router,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.subs.push(
      this.currentUser.pipe(
        filter(u => !!u),
        distinctUntilChanged()
      ).subscribe(
        () => {
          this.router.navigate(['home']);
        }
      )
    );

    this.loginForm = this.fb.group({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required)
    });
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  onSubmit() {
    const {username, password} = this.loginForm.getRawValue();
    this.store.dispatch(
      new UserLogin(
        btoa(
          `${username}:${password}`
        )
      )
    );
  }
}
